var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.data.item.service_mappings || []),function(m){return _c('div',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(m.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }